import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Paths that remain blocked when the app runs in read-only "store" mode
 * (mobile builds for App Store / Play Store). Anything that allows creating,
 * editing or otherwise managing data is unreachable, even via deep links.
 */
const BLOCKED_IN_STORE_MODE = [
  'usuarios',
  'organizaciones',
  'organizacion-perfil',
  'facturacion',
  'logs-usuarios',
  'manuales',
  'soporte',
  'proximamente',
  'alertas/configuracion'
];

/**
 * Blocks navigation to non-visualization sections when `storeMode` is enabled.
 * When store mode is off (web / Firebase hosting builds) it is a no-op.
 */
export const storeModeGuard: CanActivateChildFn = (_route, state): boolean | UrlTree => {
  if (!environment.storeMode) {
    return true;
  }

  const router = inject(Router);
  // Strip the leading slash and any query string / fragment.
  const path = state.url.split(/[?#]/)[0].replace(/^\//, '');

  const isBlocked = BLOCKED_IN_STORE_MODE.some(
    blocked => path === blocked || path.startsWith(`${blocked}/`)
  );

  return isBlocked ? router.createUrlTree(['inicio']) : true;
};
